module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "navbar",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('Hamburger', {
    staticClass: "hamburger-container",
    attrs: {
      "toggleClick": _vm.toggleSideBar,
      "isActive": _vm.sidebar.opened
    }
  }), _vm._v(" "), _c('levelbar'), _vm._v(" "), (_vm.log.length > 0) ? _c('ErrLog', {
    staticClass: "errLog-container",
    attrs: {
      "logsList": _vm.log
    }
  }) : _vm._e(), _vm._v(" "), _c('el-dropdown', {
    staticClass: "avatar-container",
    attrs: {
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "avatar-wrapper"
  }, [_c('img', {
    staticClass: "user-avatar",
    attrs: {
      "src": _vm.avatar + '?imageView2/1/w/80/h/80'
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "user-dropdown",
    slot: "dropdown"
  }, [_c('router-link', {
    staticClass: "inlineBlock",
    attrs: {
      "to": "/"
    }
  }, [_c('el-dropdown-item', [_vm._v("\n                    首页\n                ")])], 1), _vm._v(" "), _c('router-link', {
    staticClass: "inlineBlock",
    attrs: {
      "to": "/admin/profile"
    }
  }, [_c('el-dropdown-item', [_vm._v("\n                    设置\n                ")])], 1), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4109359a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Navbar.vue
// module id = 270
// module chunks = 30